declare global {
  interface Window {
    didomiOnReady?: any
  }
}

export const useDidomi = () => {
  const logger = useFrontendLogger()

  const init = () => {
    if (window) {
      const runtimeConfig = useRuntimeConfig()
      const didomiConfig = runtimeConfig.public.didomi
      if (didomiConfig?.enabled) {
        if (!didomiConfig.src) {
          logger?.warn(`Didomi ENABLED but 'config.public.didomi.src' missing`)
          return
        }
        logger?.info('Didomi ENABLED')
        useHead({
          script: [
            {
              src: didomiConfig.src,
              id: didomiConfig.id || 'cnc_cpex_cmp',
              type: 'application/javascript',
            }
          ],
        })

        const gtm = useGtm()

        window.didomiOnReady = window.didomiOnReady || []
        window.didomiOnReady.push(function (Didomi: any) {
          // enable GTM
          if (didomiConfig.gtmEnabled) {
            logger?.info('Didomi GTM ENABLED')
            gtm?.enable(true)
          }
        });
      }
    }
  }

  return {
    init,
  }
}


